import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Loads the Seertech entity list once and derives the region option set.
export const useEntityRegionOptions = () => {
  const [entities, setEntities] = useState([]);
  useEffect(() => {
    axios.get(`${API_URL}/api/settings/seertech-entities`, { withCredentials: true })
      .then(res => setEntities(res.data?.entities || []))
      .catch(() => setEntities([]));
  }, []);
  const regions = useMemo(() => {
    const set = new Set();
    entities.forEach(en => {
      (en.regions || []).forEach(r => set.add(r));
      if (en.region) set.add(en.region);
    });
    return [...set].sort();
  }, [entities]);
  return { entities, regions };
};

const Chip = ({ active, onClick, testId, children }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`text-[10px] px-2 py-0.5 rounded-full border transition-colors ${
      active
        ? 'bg-[#0F2040] text-white border-[#0F2040]'
        : 'border-slate-300 text-slate-600 hover:border-slate-400'
    }`}>{children}</button>
);

/** Entity / Region chip filters — same look & toggle behaviour as Workspaces. */
export const EntityRegionFilterChips = ({
  entities, regions, entityFilter, regionFilter,
  setEntityFilter, setRegionFilter, idPrefix = 'erf',
}) => {
  const toggle = (setter) => (val) => setter(prev =>
    prev.includes(val) ? prev.filter(x => x !== val) : [...prev, val]);
  if (!entities.length && !regions.length) return null;
  return (
    <>
      {entities.length > 0 && (
        <div>
          <div className="text-[9px] uppercase tracking-wide text-slate-400 mb-1">Entity</div>
          <div className="flex flex-wrap items-center gap-1">
            {entities.map((en) => (
              <Chip key={en.id} active={entityFilter.includes(en.id)}
                onClick={() => toggle(setEntityFilter)(en.id)}
                testId={`${idPrefix}-entity-${en.id}`}>{en.code || en.id}</Chip>
            ))}
          </div>
        </div>
      )}
      {regions.length > 0 && (
        <div>
          <div className="text-[9px] uppercase tracking-wide text-slate-400 mb-1">Region</div>
          <div className="flex flex-wrap items-center gap-1">
            {regions.map((r) => (
              <Chip key={r} active={regionFilter.includes(r)}
                onClick={() => toggle(setRegionFilter)(r)}
                testId={`${idPrefix}-region-${r.toLowerCase()}`}>{r}</Chip>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default EntityRegionFilterChips;
